import { getCarFault, getDriverViolation, insertRequestRepair, pushViolation, updateHandleState, selectFaultType, selectViolationType, getUserProfile, updateUserProfile, switchLanguage } from "../../api/config/modules/navMenu";

const state = {
    getCarFault: {},
    getDriverViolation: {},
    insertRequestRepair: {},
    pushViolation: {},
    updateHandleState: {},
    selectFaultType: {},
    selectViolationType: {},
    getUserProfile: {},
    updateUserProfile: {},
    switchLanguage: {}
};

const mutations = {
    SET_GETCARFAULT: (state, getCarFault) => {
        state.getCarFault = getCarFault;
    },
    SET_GETDRIVERVIOLATION: (state, getDriverViolation) => {
        state.getDriverViolation = getDriverViolation;
    },
    SET_INSERTREQUESTREPAIR: (state, insertRequestRepair) => {
        state.insertRequestRepair = insertRequestRepair;
    },
    SET_PUSHVIOLATION: (state, pushViolation) => {
        state.pushViolation = pushViolation;
    },
    SET_UPDAYEHANDLESTATE: (state, updateHandleState) => {
        state.updateHandleState = updateHandleState;
    },
    SET_SELECTFAULTTYPE: (state, selectFaultType) => {
        state.selectFaultType = selectFaultType;
    },
    SET_SELECTVIOLATIONTYPE: (state, selectViolationType) => {
        state.selectViolationType = selectViolationType;
    },
    SET_GETUSERPROFILE: (state, getUserProfile) => {
        state.getUserProfile = getUserProfile;
    },
    SET_UPDATEUSERPROFILE: (state, updateUserProfile) => {
        state.updateUserProfile = updateUserProfile;
    },
    SET_SWITCHLANGUAGE: (state, switchLanguage) => {
        state.switchLanguage = switchLanguage;
    },
};

const actions = {
    GET_GETCARFAULT: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            getCarFault(data)
                .then((res) => {
                    commit("SET_GETCARFAULT", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_GETDRIVERVIOLATION: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            getDriverViolation(data)
                .then((res) => {
                    commit("SET_GETDRIVERVIOLATION", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_INSERTREQUESTREPAIR: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            insertRequestRepair(data)
                .then((res) => {
                    commit("SET_INSERTREQUESTREPAIR", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_PUSHVIOLATION: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            pushViolation(data)
                .then((res) => {
                    commit("SET_PUSHVIOLATION", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPDAYEHANDLESTATE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            updateHandleState(data)
                .then((res) => {
                    commit("SET_UPDAYEHANDLESTATE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_SELECTFAULTTYPE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectFaultType(data)
                .then((res) => {
                    commit("SET_SELECTFAULTTYPE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_SELECTVIOLATIONTYPE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectViolationType(data)
                .then((res) => {
                    commit("SET_SELECTVIOLATIONTYPE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_GETUSERPROFILE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            getUserProfile(data)
                .then((res) => {
                    commit("SET_GETUSERPROFILE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPDATEUSERPROFILE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            updateUserProfile(data)
                .then((res) => {
                    commit("SET_UPDATEUSERPROFILE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_SWITCHLANGUAGE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            switchLanguage(data)
                .then((res) => {
                    commit("SET_SWITCHLANGUAGE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
